'use strict';

/* eslint-env browser */

module.exports = async function fetchTextBrowser(url) {
    const result = await fetch(url);
    return result.text();
};



// WEBPACK FOOTER //
// ./packages/mf-from-google-sheet/src/util/fetchTextBrowser.js